export const GET_RENEWAL_CONFIG_REQUEST = 'GET_RENEWAL_CONFIG_REQUEST';
export const GET_RENEWAL_CONFIG_SUCCESS = 'GET_RENEWAL_CONFIG_SUCCESS';
export const GET_RENEWAL_CONFIG_FAILURE = 'GET_RENEWAL_CONFIG_FAILURE';

export const UPDATE_RENEWAL_CONFIG_REQUEST = 'UPDATE_RENEWAL_CONFIG_REQUEST';
export const UPDATE_RENEWAL_CONFIG_SUCCESS = 'UPDATE_RENEWAL_CONFIG_SUCCESS';
export const UPDATE_RENEWAL_CONFIG_FAILURE = 'UPDATE_RENEWAL_CONFIG_FAILURE';

export const getRenewalConfigRequest = (companyId) => ({
    type: GET_RENEWAL_CONFIG_REQUEST,
    payload: { companyId }
});
export const getRenewalConfigSuccess = (config) => ({
    type: GET_RENEWAL_CONFIG_SUCCESS,
    payload: { config }
});
export const getRenewalConfigFailure = (error) => ({
    type: GET_RENEWAL_CONFIG_FAILURE,
    payload: { error }
});

export const updateRenewalConfigRequest = (companyId, data) => ({
    type: UPDATE_RENEWAL_CONFIG_REQUEST,
    payload: { companyId, data }
});
export const updateRenewalConfigSuccess = (config) => ({
    type: UPDATE_RENEWAL_CONFIG_SUCCESS,
    payload: { config }
});
export const updateRenewalConfigFailure = (error) => ({
    type: UPDATE_RENEWAL_CONFIG_FAILURE,
    payload: { error }
});
